var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.068,
    height: 15.689,
    viewBox: "0 0 21.068 15.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Video",
    "data-name": "Iconly/Light-Outline/Video",
    transform: "translate(0.002 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video",
    transform: "translate(-0.002 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.157,0h4.99A4.216,4.216,0,0,1,15.659,3.8v.395l2.1-1.718a2.02,2.02,0,0,1,3.308,1.575l-.012,7.429a2.017,2.017,0,0,1-3.3,1.559l-2.077-1.727V11.4a4.019,4.019,0,0,1-1.071,2.894,4.268,4.268,0,0,1-2.994,1.375h-7.1q-.16.012-.322.012A4.186,4.186,0,0,1,.016,11.889V9.87A.816.816,0,0,1,0,9.713V4.273A4,4,0,0,1,1.074,1.389,4.271,4.271,0,0,1,4.066,0H6.157ZM11.2,1.527H4.122a2.758,2.758,0,0,0-1.928.89,2.522,2.522,0,0,0-.671,1.825v7.543a2.681,2.681,0,0,0,2.928,2.363h7.1a2.756,2.756,0,0,0,1.928-.89,2.513,2.513,0,0,0,.673-1.82v-.012h0V3.9A2.694,2.694,0,0,0,11.2,1.529Zm7.521,2.132L15.667,6.151V9.074h0l3.043,2.8a.5.5,0,0,0,.823-.389l.012-7.429a.5.5,0,0,0-.823-.389Z",
    transform: "translate(0.002 0.008)",
    fill: "#303036",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3382a8a4.svg";
export { ForwardRef as ReactComponent };